import React, { useState } from 'react';
import Navbar from './Navbar'; //  Import Navbar
import ChatList from './ChatList';
import ChatWindow from './ChatWindow';

const ChatPage = () => {
  const [selectedChatUserId, setSelectedChatUserId] = useState(null);

  const handleSelectChat = (id) => {
    console.log("Selected Chat ID:", id);
    setSelectedChatUserId(id);
  };

  return (
    <div className="h-screen flex flex-col">
      {/*  Navbar at the top */}
      <Navbar />

      {/* Main chat section (fills remaining space) */}
      <div className="flex flex-1 overflow-hidden">
        {/* Chat list - full height & scrollable */}
        <div className="w-1/4 bg-gray-900 overflow-y-auto">
          <ChatList onSelectChat={handleSelectChat} />
        </div>

        {/* Chat window - takes up remaining space */}
        <div className="flex-1 flex flex-col h-full">
          {selectedChatUserId ? (
            <ChatWindow selectedChatUserId={selectedChatUserId} />
          ) : (
            <div className="flex-1 flex justify-center items-center bg-gray-900 text-white">
              <h2>Select a chat to start messaging</h2>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatPage;
